module.exports = __webpack_public_path__ + "static/img/k5.6814020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/k5.png
// module id = bC9v
// module chunks = 1